import {
	ADD_MODULE,
	ADD_MODULE_SUCCESS,
	ADD_MODULE_FAIL,
	ADD_MODULE_RESET,
} from '../actions/addModuleAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const addModuleReducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_MODULE:
			return {
				...state,
				apiState: 'loading',
			};
		case ADD_MODULE_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case ADD_MODULE_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case ADD_MODULE_RESET:
			return initialState;
		default:
			return state;
	}
};

export default addModuleReducer;
